module.exports = __webpack_public_path__ + "static/media/CSS3.b5faa274.png";